/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOApplyLoanModal from './DTOApplyLoanModal';
import ApplyLoanModalPresenter from './ApplyLoanModalPresenter';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { loanService } from '../../../../api/services/loanService';
import { setAllActiveLoans } from '../../../../infra/aggregates/myProfile/loansAggregates/activeLoansSlice';
import { setAllLoansHistory } from '../../../../infra/aggregates/myProfile/loansAggregates/loansHistorySlice';
import toast from 'react-hot-toast';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const ApplyLoanModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);

  const [loanTypes, setLoanTypes] = useState([]);
  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    applyLoan(data);
  };

  const getLoanTypes = (data: any) => {
    setLoanTypes(data);
  };

  async function applyLoan(data: any) {
    if (selector) {
      const payload = {
        emp_id: selector.emp_id,
        duration: data.duration,
        amount: data.amount,
        start_date: data.startDate,
        loan_type_id: data.loan_type_id,
        comment: data.comment,
      };

      await loanService
        .applyLoan(payload)
        .then((response) => {
          if (response.response == 'success') {
            dispatch(setAllActiveLoans(response?.data?.applied_loans));
            dispatch(setAllLoansHistory(response?.data?.loans_history));
            closeModal();
            toast.success(trans('Added Successfully'));
          }
        })
        .catch((err) => {
          if (err?.error?.data) {
            toast.error(err?.error?.data);
          } else {
            const _errors = Object.keys(err?.response?.data?.errors);
            toast.error(`${_errors.toString().toUpperCase()} Required!`);
          }
        });
    }
  }

  return (
    <>
      <DTOApplyLoanModal setAllLoanTypesData={getLoanTypes} />

      <ApplyLoanModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allLoanTypes={loanTypes}
        trans={trans}
      />
    </>
  );
};

export default ApplyLoanModalController;
